import { useAdViewAd } from "src/context/AdViewProviderContext.tsx";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import { FeatureIds } from "src/types/unleash.ts";
import { RangeAndBatteryCard } from "./RangeAndBatteryCard.tsx";

export const EvInfoSection = () => {
  const ad = useAdViewAd();
  const { featureToggles } = useAppConfig();

  if (!featureToggles[FeatureIds.ENABLE_EV_INFO_SECTION]) {
    return null;
  }

  if (!("ev_info_links" in ad) || !ad.ev_info_links) {
    return null;
  }

  return (
    <div
      data-testid="ev-info"
      className="relative mt-40 p-16 flex flex-col gap-16 s-bg-info-subtle dark:s-bg-subtle -mx-16 md:mx-0 md:rounded-8"
    >
      <RangeAndBatteryCard ad={ad} />
    </div>
  );
};
